Namespace 'Monitoring.Reports.Publications.Sections'

class Monitoring.Reports.Publications.Sections.RankingsView extends Backbone.View

  tagName: 'section'
  template: JST['backbone/templates/monitoring/reports/publications/section']

  initialize: (@options = {}) ->
    # just set @options

  render_twitter:->
    @$el.html(@template(@options))
    @$el.append(@spinner())
    return this
    
  render: ->
    @$el.html(@template(@options))
    @$el.append(@spinner())
    return this

  fill_rankings: (data) ->
    @$('.spinner').remove()
    ranking_views = []
    $.each data, (ranking_name, ranking_data) =>
      ranking_options = { name: ranking_name, data: ranking_data, contents: @options.contents }
      ranking_views.push(new Monitoring.Reports.Publications.RankingView(ranking_options))

    table = $('<table/>').attr('id', 'rankings')
    _.eachSlice ranking_views, 2, (group) ->
      tr = $('<tr/>')
      _.each group, (ranking_view) ->
        ranking_view.render()
        td = $('<td/>')
        td.html(ranking_view.el)
        tr.append(td)
      table.append(tr)
    @$('.container').append(table)

  spinner: ->
    spinner = $('<div/>').addClass('spinner')
    spinner.css('text-align', 'center').css('padding', '15px')
    spinner.append $('<div/>').addClass('bounce1')
    spinner.append $('<div/>').addClass('bounce2')
    spinner.append $('<div/>').addClass('bounce3')

  fail: =>
    # TODO generic template (with content_view)
    error_message = I18n.t("monitoring.dashboard.publications.error")
    @$('.spinner').replaceWith("<div class='error'><i class='fa fa-exclamation-triangle'></i> #{error_message}</div>")
